<div class="content__inner">
    <header class="content__title">
        <h1 *ngIf="MODE === 'ADD'">{{ 'categories.detail.add.title' | translate }}</h1>
        <h1 *ngIf="MODE === 'EDIT'">{{ 'categories.detail.edit.title' | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i>
                {{ 'global.buttons.back' | translate }}</button>
        </div>
    </header>

    <div class="card">
        <div class="card-body">
            <form name="form" class="row" *ngIf="category" (ngSubmit)="f.form.valid && save()" #f="ngForm" novalidate>
                <div class="col-md-6">

                    <div class="form-group">
                        <label>{{ 'categories.props.key' | translate }}</label>
                        <input name="key" type="text" class="form-control" [(ngModel)]="category.key" #key="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && key.invalid }" required />
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ 'categories.detail.validation.key' | translate }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'categories.props.color' | translate }}</label>
                        <input name="color" type="text" class="form-control" [(ngModel)]="category.color" #color="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && color.invalid }" required />
                        <i class="form-group__bar"></i>
                        <div class="invalid-tooltip">
                            {{ 'categories.detail.validation.color' | translate }}
                        </div>
                    </div>

                    
                </div>

                <div class="col-md-12">
                    <tabset>
                        <tab *ngFor="let translation of category.translations; let idx = index" [heading]="languageNameByIso(translation.iso)">

                            <div class="form-group">
                                <label>{{ 'categories.props.name' | translate }}</label>
                                <input name="name_{{idx}}" type="text" class="form-control" [(ngModel)]="category.translations[idx].name"/>
                                <i class="form-group__bar"></i>
                            </div>

                        </tab>
                    </tabset>
                </div>

                <div class="col-md-12">
                    <button class="float-right btn btn-success btn--icon-text" [disabled]="f.submitted && f.invalid"><i
                            class="zmdi zmdi-check"></i> {{ 'global.buttons.save' | translate }}</button>
                </div>

            </form>
        </div>
    </div>
</div>